import { initializeApp } from 'firebase/app';
import { getToken, onMessage, isSupported, getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);

export const setupMessaging = async () => {
  const supported = await isSupported();
  if (!supported) return null;
  return getMessaging(firebaseApp);
};

export const requestFcmToken = async (
  messaging: any,
  vapidKey: string,
  serviceWorkerRegistration?: ServiceWorkerRegistration
) => {
  const token = await getToken(messaging, { vapidKey, serviceWorkerRegistration });
  return token;
};

export const listenForegroundMessage = (messaging: any, handler: (payload: any) => void) =>
  onMessage(messaging, handler);
